<template>
  <EditarBase
    nomeSingular="FuncionarioPreContratracaoDocumentos"
    nomePlural="FuncionarioPreContratracaoDocumentos"
    @recurso="setRecurso"
    @submitSuccess="emitSubmitSuccess"
    @submitError="emitSubmitError"
    @closeModalEdit="closeModalEdit"
  >
    <v-col cols="12" md="12">
      <span class="opacity-5 text-dark">
        {{ $t("Descricao") }}
      </span>
      <v-text-field
        v-model="recurso.descricao"
        :label="$t('Descricao')"
        name="descricao"
        obrigatorio
        class="
          input-style
          font-size-input
          text-light-input
          placeholder-light
          input-icon
        "
        dense
        flat
        filled
        solo
      >
      </v-text-field>
    </v-col>
    <v-col cols="12" md="4">
      <span class="opacity-5 text-dark">
        {{ $t("Status") }}
      </span>
      <v-select
        v-model="recurso.statusComum"
        :items="statusComumItems"
        item-text="text"
        item-value="value"
        :label="$t('Status')"
        class="
          input-style
          font-size-input
          text-light-input
          placeholder-light
          input-icon
        "
        dense
        flat
        filled
        solo
      ></v-select>
    </v-col>
    <v-col cols="12" md="4">
      <v-checkbox v-model="recurso.obrigatorio">
        <template v-slot:label>
          {{ $t("Obrigatorio") }}
        </template>
      </v-checkbox>
    </v-col>
    <v-col cols="12" md="4">
      <v-checkbox v-model="recurso.obrigatorioSexoMasculino">
        <template v-slot:label>
          {{ $t("Obrigatorio_para_masculino") }}
        </template>
      </v-checkbox>
    </v-col>
    <v-col cols="12" md="4">
      <v-checkbox v-model="recurso.obrigatorioSexoFeminino">
        <template v-slot:label>
          {{ $t("Obrigatorio_para_feminino") }}
        </template>
      </v-checkbox>
    </v-col>
    <v-col cols="12" md="4">
      <v-checkbox v-model="recurso.obrigatorioNivelSuperior">
        <template v-slot:label>
          {{ $t("Obrigatorio_para_nivel_superior") }}
        </template>
      </v-checkbox>
    </v-col>
    <v-col cols="12" md="4">
      <v-checkbox v-model="recurso.obrigatorioNivelNaoSuperior">
        <template v-slot:label>
          {{ $t("Obrigatorio_para_nivel_nao_superior") }}
        </template>
      </v-checkbox>
    </v-col>
  </EditarBase>
</template>

<script>
import EditarBase from "@/components/base/Crud/EditarBase";
import DataService from "@/services/pessoal/FuncionarioPreContratracaoDocumentosDataService";

export default {
  name: "EditarFuncionarioPreContratracaoDocumentos",
  components: { EditarBase },
  props: {
    itemAtual: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      DataService,
      recurso: this.defaultRecurso(),
      statusComumItems: [
        { text: this.$t("Ativo"), value: "ATIVO" },
        { text: this.$t("Inativo"), value: "INATIVO" },
      ],
      errors: [],
    };
  },
  watch: {
    itemAtual: {
      handler(newValue) {
        this.inicializaRecurso(newValue);
      },
      immediate: true,
    },
  },
  methods: {
    defaultRecurso() {
      return {
        id: null,
        descricao: "",
        obrigatorio: true,
        obrigatorioSexoMasculino: true,
        obrigatorioSexoFeminino: true,
        obrigatorioNivelSuperior: false,
        obrigatorioNivelNaoSuperior: false,
        statusComum: "ATIVO",
      };
    },
    extractPayload(responseData) {
      if (
        responseData &&
        typeof responseData === "object" &&
        responseData.present === true &&
        responseData.value
      ) {
        return responseData.value;
      }
      return responseData;
    },
    normalizeRecurso(recurso = {}) {
      return {
        ...this.defaultRecurso(),
        ...recurso,
        obrigatorio: recurso?.obrigatorio ?? true,
        obrigatorioSexoMasculino: recurso?.obrigatorioSexoMasculino ?? true,
        obrigatorioSexoFeminino: recurso?.obrigatorioSexoFeminino ?? true,
        obrigatorioNivelSuperior: recurso?.obrigatorioNivelSuperior ?? false,
        obrigatorioNivelNaoSuperior:
          recurso?.obrigatorioNivelNaoSuperior ?? false,
        statusComum: recurso?.statusComum ?? "ATIVO",
      };
    },
    setRecurso(recurso) {
      this.recurso = this.normalizeRecurso(recurso);
    },
    inicializaRecurso(item) {
      this.setRecurso(item || {});

      const id = item?.id || this.$route?.params?.id;
      if (id && !item?.id) {
        this.carregaRecursoCompleto(id);
      }
    },
    async carregaRecursoCompleto(id) {
      try {
        const response = await this.DataService.find(id);
        const payload = this.extractPayload(response.data);
        if (payload && typeof payload === "object" && payload.id) {
          this.setRecurso(payload);
        }
      } catch (error) {
        // Mantem os dados atuais caso a busca detalhada falhe.
      }
    },
    emitSubmitSuccess(recursoAtualizado = this.recurso) {
      this.$emit("submitSuccess", recursoAtualizado);
    },
    emitSubmitError() {
      this.$emit("submitError");
    },
    closeModalEdit() {
      this.$emit("closeModalEdit");
    },
  },
};
</script>

<style scoped></style>
